import { myBookingApi } from '../../../api/booking/booking.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myToastService } from '../../front/ToastService/ToastService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { createBookingMutationService } from './BookingMutationService.impl';

export const myBookingMutationService = createBookingMutationService({
  api: myBookingApi,
  services: {
    errorService: myErrorService,
    messageService: myMessageService,
    toastService: myToastService
  }
});
